/**
 * The Essential Wet Shaving Starter Kit — selection engine + add-to-cart.
 * Bound to this kit's three slots (soap, brush, razor) and its own offer token,
 * plus optional add-ons (after-shave balm, pre-shave oil, gray marble bowl).
 * Cart flow mirrors the theme's product form: /cart/add.js -> /cart.js ->
 * cartUpdate pubsub -> cart drawer opens.
 */
(function () {
  'use strict';

  var TOKEN = 'essential-wet-shaving-kit';
  var KIT_LABEL = 'The Essential Wet Shaving Starter Kit';
  var state = { scent: 'sandalwood', finish: 'classic' };
  var addingKit = false;

  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

  /* ---------- money ---------- */
  function money(cents) {
    var fmt = (window.theme && theme.settings && theme.settings.moneyFormat) || '${{amount}}';
    var value = (cents / 100).toFixed(2);
    var whole = String(Math.round(cents / 100));
    var out = fmt
      .replace(/\{\{amount\}\}/g, value)
      .replace(/\{\{amount_no_decimals\}\}/g, whole)
      .replace(/\{\{amount_with_comma_separator\}\}/g, value.replace('.', ','))
      .replace(/\{\{amount_no_decimals_with_comma_separator\}\}/g, whole);
    return out.replace(/<[^>]*>/g, '').trim();
  }
  function moneyShort(cents) {
    var m = money(cents);
    return cents % 100 === 0 ? m.replace(/\.00$/, '') : m;
  }

  /* ---------- selection ---------- */
  function cards() { return $$('[data-fudge-kit-card]'); }

  function cardMatches(card) {
    var scents = (card.getAttribute('data-scent') || 'all').split(' ');
    if (scents.indexOf('all') === -1 && scents.indexOf(state.scent) === -1) return false;
    var finish = card.getAttribute('data-finish');
    if (finish && finish !== state.finish) return false;
    return true;
  }
  function kitCards() { return cards().filter(cardMatches); }

  function refreshCards() {
    cards().forEach(function (card) {
      if (cardMatches(card)) card.removeAttribute('hidden');
      else card.setAttribute('hidden', '');
    });
  }

  function refreshAddons() {
    $$('[data-fudge-kit-addon]').forEach(function (card) {
      $$('[data-addon-scent]', card).forEach(function (el) {
        if (el.getAttribute('data-addon-scent') === state.scent) el.removeAttribute('hidden');
        else el.setAttribute('hidden', '');
      });
      var chk = $('[data-fudge-kit-addon-toggle]', card);
      if (chk) {
        var vId = chk.getAttribute('data-variant-id-' + state.scent);
        if (vId) chk.setAttribute('data-variant-id', vId);
      }
      var btn = $('[data-fudge-kit-addon-add]', card);
      if (btn) {
        var vIdBtn = btn.getAttribute('data-variant-id-' + state.scent);
        if (vIdBtn) btn.setAttribute('data-variant-id', vIdBtn);
      }
    });
  }

  function refreshPills() {
    $$('[data-fudge-kit-scent]').forEach(function (pill) {
      var active = pill.getAttribute('data-fudge-kit-scent') === state.scent;
      pill.classList.toggle('is-active', active);
      pill.setAttribute('aria-pressed', active ? 'true' : 'false');
    });
    $$('[data-fudge-kit-finish]').forEach(function (pill) {
      var active = pill.getAttribute('data-fudge-kit-finish') === state.finish;
      pill.classList.toggle('is-active', active);
      pill.setAttribute('aria-pressed', active ? 'true' : 'false');
    });
  }

  function kitPriceCents() {
    var el = $('[data-kit-price-cents]');
    return el ? parseInt(el.getAttribute('data-kit-price-cents'), 10) || 6795 : 6795;
  }

  function selectedAddons() {
    return $$('[data-fudge-kit-addon-toggle]:checked').map(function (chk) {
      return {
        variantId: chk.getAttribute('data-variant-id'),
        price: parseInt(chk.getAttribute('data-price'), 10) || 0,
        title: chk.getAttribute('data-title') || 'Add-on'
      };
    });
  }

  function showKitError(message) {
    $$('[data-fudge-kit-error]').forEach(function (el) {
      el.textContent = message;
      el.classList.add('is-visible');
    });
  }
  function clearKitError() {
    $$('[data-fudge-kit-error]').forEach(function (el) { el.classList.remove('is-visible'); });
  }

  function recompute() {
    var parts = kitCards();
    var separate = parts.reduce(function (sum, card) {
      return sum + (parseInt(card.getAttribute('data-price'), 10) || 0);
    }, 0);
    var kit = kitPriceCents();
    var save = Math.max(separate - kit, 0);
    var percent = separate > 0 ? Math.round((save / separate) * 100) : 0;

    var addons = selectedAddons();
    var addonsTotal = addons.reduce(function (sum, a) { return sum + a.price; }, 0);
    var grandTotal = kit + addonsTotal;

    $$('[data-kit-separate]').forEach(function (el) { el.textContent = money(separate); });
    $$('[data-kit-save]').forEach(function (el) { el.textContent = moneyShort(save); });
    $$('[data-kit-save-percent]').forEach(function (el) { el.textContent = String(percent); });

    // Update summary addons list
    var summaryAddons = $('[data-fudge-kit-summary-addons]');
    if (summaryAddons) {
      if (addons.length > 0) {
        summaryAddons.innerHTML = addons.map(function (a) {
          return '<div class="fudge-kit-summary__addon-item"><span>+ ' + a.title + '</span><strong>' + money(a.price) + '</strong></div>';
        }).join('');
        summaryAddons.removeAttribute('hidden');
      } else {
        summaryAddons.innerHTML = '';
        summaryAddons.setAttribute('hidden', '');
      }
    }

    // Update total price display
    $$('[data-kit-price]').forEach(function (el) { el.textContent = money(grandTotal); });

    // Update CTA button labels
    var ctaText = addons.length > 0
      ? 'Add Kit & Add-on' + (addons.length > 1 ? 's' : '') + ' to Cart — ' + money(grandTotal)
      : 'Add the Kit to Cart — Save ' + moneyShort(save);

    $$('[data-fudge-kit-add] .btn-text').forEach(function (el) {
      el.textContent = ctaText;
    });

    var soldOut = parts.some(function (card) { return card.getAttribute('data-available') === 'false'; });
    $$('[data-fudge-kit-add]').forEach(function (btn) {
      if (addingKit) return;
      btn.setAttribute('aria-disabled', soldOut ? 'true' : 'false');
    });
    if (soldOut) showKitError("One of the kit pieces is sold out right now — write to us and we'll tell you the moment it's back.");
    else clearKitError();
  }

  /* ---------- cart (mirrors the theme's product form) ---------- */
  function routes() {
    return (window.theme && theme.routes) || { cart_add_url: '/cart/add', cart_url: '/cart' };
  }

  function addToCart(items) {
    var sectionsToBundle = [];
    document.documentElement.dispatchEvent(new CustomEvent('cart:bundled-sections', {
      bubbles: true,
      detail: { sections: sectionsToBundle }
    }));
    var r = routes();
    return fetch(r.cart_add_url + '.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/javascript',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({
        items: items,
        sections: sectionsToBundle.join(','),
        sections_url: window.location.pathname
      })
    })
      .then(function (response) {
        return response.json().then(function (parsed) {
          if (!response.ok || parsed.status) {
            throw new Error(parsed.description || parsed.message || 'Could not add to cart.');
          }
          return parsed;
        });
      })
      .then(function (parsed) {
        return fetch(r.cart_url + '.js', { headers: { Accept: 'application/json' } })
          .then(function (response) { return response.json(); })
          .then(function (cart) {
            cart.sections = parsed.sections;
            if (window.theme && theme.pubsub && theme.pubsub.PUB_SUB_EVENTS) {
              theme.pubsub.publish(theme.pubsub.PUB_SUB_EVENTS.cartUpdate, { source: 'product-form', cart: cart });
            } else {
              document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { open: true } }));
            }
            document.dispatchEvent(new CustomEvent('ajaxProduct:added', { detail: { product: parsed } }));
            var drawer = document.querySelector('cart-drawer');
            if (drawer && typeof drawer.show === 'function') {
              drawer.show();
            } else {
              document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { open: true } }));
            }
          });
      });
  }

  function kitItems() {
    var items = kitCards().map(function (card) {
      return {
        id: parseInt(card.getAttribute('data-variant-id'), 10),
        quantity: 1,
        properties: {
          _fudge: JSON.stringify({ offer: TOKEN, slot: card.getAttribute('data-slot') }),
          'Starter Kit': KIT_LABEL
        }
      };
    });
    selectedAddons().forEach(function (a) {
      items.push({
        id: parseInt(a.variantId, 10),
        quantity: 1,
        properties: {
          'Add-on to': KIT_LABEL
        }
      });
    });
    return items;
  }

  function handleKitAdd() {
    if (addingKit) return;
    var parts = kitCards();
    if (!parts.length) return;
    var soldOut = parts.some(function (card) { return card.getAttribute('data-available') === 'false'; });
    if (soldOut) { recompute(); return; }

    addingKit = true;
    var buttons = $$('[data-fudge-kit-add]');
    buttons.forEach(function (btn) {
      btn.setAttribute('aria-disabled', 'true');
      btn.setAttribute('aria-busy', 'true');
    });

    addToCart(kitItems())
      .then(
        function () { clearKitError(); },
        function (error) { showKitError((error && error.message) || 'Could not add to cart.'); }
      )
      .then(function () {
        addingKit = false;
        buttons.forEach(function (btn) {
          btn.removeAttribute('aria-busy');
          btn.removeAttribute('aria-disabled');
        });
        recompute();
      });
  }

  function handleAddonAdd(button) {
    if (button.getAttribute('aria-disabled') === 'true' || button.getAttribute('aria-busy') === 'true') return;
    var id = parseInt(button.getAttribute('data-variant-id'), 10);
    button.setAttribute('aria-disabled', 'true');
    button.setAttribute('aria-busy', 'true');
    var textEl = button.querySelector('.btn-text');
    var origText = textEl ? textEl.textContent : '';
    if (textEl) textEl.textContent = 'Adding...';

    addToCart([{ id: id, quantity: 1 }])
      .then(
        function () {
          clearKitError();
          if (textEl) textEl.textContent = 'Added!';
          setTimeout(function () {
            if (textEl) textEl.textContent = origText;
            button.removeAttribute('aria-disabled');
          }, 1500);
        },
        function (error) {
          showKitError((error && error.message) || 'Could not add to cart.');
          if (textEl) textEl.textContent = origText;
          button.removeAttribute('aria-disabled');
        }
      )
      .then(function () {
        button.removeAttribute('aria-busy');
      });
  }

  function handleAddonToggle(checkbox) {
    var card = checkbox.closest('[data-fudge-kit-addon]');
    if (card) {
      card.classList.toggle('is-checked', checkbox.checked);
      var label = card.querySelector('.fudge-kit-addon__toggle-label');
      var price = money(parseInt(checkbox.getAttribute('data-price'), 10) || 0);
      if (label) {
        label.textContent = checkbox.checked
          ? '✓ Included with kit (+' + price + ')'
          : 'Include with kit (+' + price + ')';
      }
    }
    recompute();
  }

  /* ---------- sticky mobile bar ---------- */
  function initStickyBar() {
    var bar = $('[data-fudge-kit-stickybar]');
    if (!bar || !('IntersectionObserver' in window)) return;
    var ctas = $$('[data-fudge-kit-add]').filter(function (el) {
      return !el.closest('[data-fudge-kit-stickybar]');
    });
    var footer = document.querySelector('.footer-group');
    if (!ctas.length) return;
    var states = ctas.map(function () { return false; });
    var footerVisible = false;

    function update() {
      var show = !states.some(Boolean) && !footerVisible;
      bar.classList.toggle('is-visible', show);
      if (show) bar.removeAttribute('hidden');
      else bar.setAttribute('hidden', '');
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.target === footer) footerVisible = entry.isIntersecting;
        else states[ctas.indexOf(entry.target)] = entry.isIntersecting;
      });
      update();
    }, { rootMargin: '-56px 0px 0px 0px' });
    ctas.forEach(function (el) { observer.observe(el); });
    if (footer) observer.observe(footer);
  }

  /* ---------- init ---------- */
  function init() {
    refreshPills();
    refreshCards();
    refreshAddons();
    recompute();

    document.addEventListener('change', function (event) {
      if (event.target && event.target.matches('[data-fudge-kit-addon-toggle]')) {
        handleAddonToggle(event.target);
      }
    });

    document.addEventListener('click', function (event) {
      var el = event.target && event.target.closest
        ? event.target.closest('[data-fudge-kit-scent], [data-fudge-kit-finish], [data-fudge-kit-add], [data-fudge-kit-addon-add]')
        : null;
      if (!el) return;
      if (el.hasAttribute('data-fudge-kit-scent')) {
        state.scent = el.getAttribute('data-fudge-kit-scent');
        refreshPills(); refreshCards(); refreshAddons(); recompute();
      } else if (el.hasAttribute('data-fudge-kit-finish')) {
        state.finish = el.getAttribute('data-fudge-kit-finish');
        refreshPills(); refreshCards(); recompute();
      } else if (el.hasAttribute('data-fudge-kit-add')) {
        handleKitAdd();
      } else if (el.hasAttribute('data-fudge-kit-addon-add')) {
        handleAddonAdd(el);
      }
    });

    initStickyBar();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
